import { render, staticRenderFns } from "./IntranetWrapper.vue?vue&type=template&id=2fe6075e&scoped=true"
import script from "./IntranetWrapper.vue?vue&type=script&lang=js"
export * from "./IntranetWrapper.vue?vue&type=script&lang=js"
import style0 from "./IntranetWrapper.vue?vue&type=style&index=0&id=2fe6075e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe6075e",
  null
  
)

export default component.exports